import { Contact, MapPinned, NotebookPen, Phone, Wrench } from 'lucide-react'

import { Locale } from 'src/types'

import { Field, FieldType, ServiceType } from 'src/pages/ServiceContacts/types'

export const getFormFields = (
  translations: Locale['serviceContacts'],
): Field[] => {
  const { addServiceContacts: locale } = translations

  return [
    {
      id: 'contactName',
      label: locale.contactName,
      placeholder: locale.contactNamePlaceholder,
      type: FieldType.INPUT,
      validation: {
        required: locale.required,
      },
      icon: Contact,
    },
    {
      id: 'phoneNumber',
      label: locale.phoneNumber,
      placeholder: locale.phoneNumberPlaceholder,
      type: FieldType.INPUT,
      validation: {
        required: locale.required,
        pattern: {
          value: /^\+([1-9][0-9]{0,2})[0-9]{7,14}$/,
          message: locale.invalidPhoneNumber,
        },
      },
      icon: Phone,
    },
    {
      id: 'serviceType',
      label: locale.serviceType,
      placeholder: locale.serviceTypePlaceholder,
      type: FieldType.SELECT,
      options: [
        {
          value: ServiceType.GENERAL_MAINTENANCE,
          label: locale.generalMaintenance,
        },
        { value: ServiceType.BODYWORK, label: locale.bodywork },
        { value: ServiceType.TIRE_SHOP, label: locale.tireShop },
      ],
      validation: {
        required: locale.required,
      },
      icon: Wrench,
    },
    {
      id: 'address',
      label: locale.address,
      placeholder: locale.addressPlaceholder,
      type: FieldType.INPUT,
      validation: {
        required: locale.required,
      },
      icon: MapPinned,
    },
    {
      id: 'additionalNotes',
      label: locale.additionalNotes,
      placeholder: locale.additionalNotesPlaceholder,
      type: FieldType.TEXTAREA,
      icon: NotebookPen,
    },
  ]
}
